import { render } from "./HeaderCard.vue?vue&type=template&id=04afa5b8&scoped=true"
import script from "./HeaderCard.vue?vue&type=script&lang=js"
export * from "./HeaderCard.vue?vue&type=script&lang=js"

import "./HeaderCard.vue?vue&type=style&index=0&id=04afa5b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04afa5b8"]])

export default __exports__